import React, { useState } from 'react';
import Game from './components/Game';
import { AuthProvider } from './context/AuthContext';
import styled from 'styled-components';

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  // padding-top: 10px;
  // align-items: center;
  position: relative;
`;

const App: React.FC = () => {
  const [isPanelCollapse, setPanelCollapse] = useState(false);
  // 处理状态栏收起/展开
  const onPanelCollapse = (value: boolean) => {
    setPanelCollapse(value);
    console.log('panelCollapse', value);
  };
  return (
    <AuthProvider>
      <AppContainer>
        <Game onPanelCollapse={onPanelCollapse} />
      </AppContainer>
    </AuthProvider>
  );
};

export default App; 